import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadSalesValidationPermissionAuditUrl,
  zadSalesValidationPermissionMeUrl,
  zadSalesValidationPermissionUrl,
} from '../../api'
import {parseZadApiError} from '../zad/errors'
import {
  extractZadSalesValidationAudits,
  extractZadSalesValidationMe,
  extractZadSalesValidationUsers,
} from '../zad/salesValidationPermissionHelpers'
import {
  FetchZadSalesValidationAuditRequest,
  SetZadSalesValidationPermissionRequest,
} from './types'

export const fetchMyZadSalesValidationPermission = createAsyncThunk(
  'zadSalesValidationPermission/fetchMe',
  async (_payload: void, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadSalesValidationPermissionMeUrl)
      const me = extractZadSalesValidationMe(res.data)
      if (!me) {
        return rejectWithValue({
          success: false as const,
          error: 'Invalid permission response',
          errorCode: 'VALIDATION_ERROR',
          status: 500,
        })
      }
      return {success: true as const, me}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadSalesValidationPermissions = createAsyncThunk(
  'zadSalesValidationPermission/fetchList',
  async (_payload: void, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadSalesValidationPermissionUrl)
      return {
        success: true as const,
        users: extractZadSalesValidationUsers(res.data),
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const setZadSalesValidationPermission = createAsyncThunk(
  'zadSalesValidationPermission/set',
  async (payload: SetZadSalesValidationPermissionRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadSalesValidationPermissionUrl, {
        userId: payload.userId,
        enabled: payload.enabled === true,
      })
      return {
        success: true as const,
        userId: payload.userId,
        enabled: res.data?.enabled === true,
        unchanged: res.data?.unchanged === true,
        action: res.data?.action || null,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadSalesValidationAudit = createAsyncThunk(
  'zadSalesValidationPermission/fetchAudit',
  async (payload: FetchZadSalesValidationAuditRequest | undefined, {rejectWithValue}) => {
    try {
      const userId = payload?.userId ? String(payload.userId).trim() : ''
      const url = userId
        ? `${zadSalesValidationPermissionAuditUrl}?userId=${encodeURIComponent(userId)}`
        : zadSalesValidationPermissionAuditUrl
      const res = await axios.get(url)
      return {
        success: true as const,
        audits: extractZadSalesValidationAudits(res.data),
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
